import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import background from "../../../media/backAbouttoop.svg";
import me from "../../../media/m3.png";
import "./About.css";
import "aos/dist/aos.css";
import Aos from "aos";

function Data() {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, []);
  return (
    <div className="data__content">
      <div
        className="container-fluid  d-flex align-items-end "
        style={{
          backgroundImage: `url(${background})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div className="container bg content-about">
          <div className="row align-items-center text-center">
            <div className="col-sm-6" data-aos="fade-right">
              <div className="container mt-5">
                <img src={me} alt="" className="img-fluid mt-2 mb-3" />
              </div>
            </div>
            <div
              className="col-sm-6 text-about about-title"
              data-aos="fade-down-left"
            >
              <h1 data-aos="fade-down-left">
                You have to know this about me <span role="img" aria-label="Pointing Down">&#128071;</span>
              </h1>
              <p data-aos="fade-down-left">
              Hey, I'm Nahal Anjum, 19. I live in Lahore, Pakistan. As a Computer Science student, I'm constantly expanding my knowledge horizons. Beyond the world of algorithms and programming languages, you'll find me indulging in my passion for web development and exploring the fascinating realm of data science. When I'm not busy with coursework, you might catch me experimenting with new web projects or dissecting data to uncover hidden insights.
              </p>
              <div className="container">
                <a
                  href={
                    process.env.PUBLIC_URL +
                    "/Nahal-Anjum-Developer.pdf"
                  }
                  download
                >
                  <Button variant="outline-dark">Download CV</Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data;
